import { cn } from 'lib/cn';
import { type ComponentProps } from 'react';

/**
 * The Kapa plate mark. Painted in `currentColor`, so it takes the surrounding
 * text colour and stays legible in either scheme; the K is knocked out of the
 * plate rather than drawn, and shows whatever sits behind it.
 */
export const KapaLogoMark = ({
  className,
  ...props
}: ComponentProps<'svg'>) => (
  <svg
    data-slot="kapa-logo-mark"
    viewBox="0 0 42 42"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('size-8', className)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M41 11C41 5.47715 36.5228 1 31 1H11C5.47715 1 1 5.47715 1 11V31C1 36.5228 5.47715 41 11 41H31C36.5228 41 41 36.5228 41 31V11ZM17.7911 31.1334C17.9384 31.1334 18.0578 31.014 18.0578 30.8668V24.9601C18.0578 24.8128 18.1772 24.6934 18.3245 24.6934H20.5888C20.6828 24.6934 20.7699 24.7429 20.818 24.8237L24.4953 31.0031C24.5433 31.0839 24.6304 31.1334 24.7244 31.1334H30.0887C30.2972 31.1334 30.425 30.905 30.316 30.7273L24.9762 22.0246C24.9215 21.9354 24.924 21.8224 24.9827 21.7357L30.3185 13.8483C30.4383 13.6712 30.3115 13.4322 30.0977 13.4322H24.7577C24.6645 13.4322 24.5781 13.4809 24.5298 13.5605L20.7138 19.8495C20.6654 19.9291 20.579 19.9778 20.4858 19.9778H18.3245C18.1772 19.9778 18.0578 19.8584 18.0578 19.7111V9.93341C18.0578 9.78614 17.9384 9.66675 17.7911 9.66675H13.1334C12.9861 9.66675 12.8667 9.78614 12.8667 9.93341V30.8668C12.8667 31.014 12.9861 31.1334 13.1334 31.1334H17.7911Z"
    />
  </svg>
);
KapaLogoMark.displayName = 'KapaLogoMark';
